<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <site-query :sites="filterSites" :query="query" />

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" @change="onUnitPropChange" />
      </template>

      <x-y-chart
        v-for="data in dataList"
        :key="data.id"
        :data-config="data"
        :unit-prop="unitProp"
        :chart-type="chartType"
        :stack-type="stackType"
        :download-name="downloadName"
        chart-min-height="400px"
        chart-height="auto"
        style="flex:1 0 100%;"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import XYChart from '../../../../components/DataChart/XYChart'

export default {
  name: 'DataDisplayPan',
  routeInfo: {
    label: 'PAN数据',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {LayoutContent, DataTimeQuery, SiteQuery, CompletedQuery, DataWrapper, UnitSwitch, XYChart},
  data: () => ({
    query: {
      factorIds: [],
      isMultipleIntegral: true
    },
    chartType: 'line',
    stackType: 0
  }),
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, true)
    ],
    downloadName: () => 'PAN'
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let param = {
        type: 'line',
        showSymbol: false
      }

      return param
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/02VOCs-Photochemical/03Pan/index.vue